import React, { useState, useEffect } from 'react';
import { Table, Button, Form, InputGroup, Spinner, Card, Row, Col } from 'react-bootstrap';
import { FaSearch, FaEdit, FaPlus } from 'react-icons/fa';
import usuariosService from '../../api/usuariosService';
import { useNavigate } from 'react-router-dom';
import './list.css';

const ListarUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();

  const fetchUsuarios = async () => {
    setLoading(true);
    try {
      const response = await usuariosService.listar();
      setUsuarios(response);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const handleSearch = (e) => {
    setBusca(e.target.value);
  };

  const usuariosFiltrados = usuarios?.filter((usuario) =>
    usuario.nome.toLowerCase().includes(busca.toLowerCase())
  );

  const handleEdit = (id) => {
    navigate(`/usuarios/${id}`);
  };

  const handleNewUser = () => {
    navigate('/usuarios');
  };

  return (
    <div className="listar-usuarios-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Lista de Usuários</Card.Title>
          <hr />
          <Row>
            <Col md={9} className="mb-3">
              <Form>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Buscar usuário por nome..."
                    value={busca}
                    onChange={handleSearch}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
            </Col>
            <Col md={3} className="text-end">
              <Button variant="success" onClick={handleNewUser}>
                <FaPlus /> Novo Usuário
              </Button>
            </Col>
          </Row>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table striped bordered hover responsive className="mb-0">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Perfil</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuariosFiltrados?.map((usuario) => (
                  <tr key={usuario.id}>
                    <td>{usuario.nome}</td>
                    <td>{usuario.email}</td>
                    <td>{usuario.perfilNome}</td>
                    <td>
                      <Button
                        style={{ backgroundColor: '#840027', borderColor: '#840027' }}
                        size="sm"
                        onClick={() => handleEdit(usuario.id)}
                      >
                        <FaEdit /> Editar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListarUsuarios;
